import  React from 'react';
import { IField, validateFieldsEx } from './FieldValidation';
import { FormItemProps } from './FormItem';
import { TextSelectField } from './SelectField';
import { TextField } from './TextField';

export interface SalutationFieldProps extends FormItemProps {
    id: string
    value: string
    label: string
    onChange: { (v: string): void }
    required?: boolean
    requiredMessage?: string
}

export interface SalutationFieldState {
}

export class SalutationField extends React.Component<SalutationFieldProps, SalutationFieldState> implements IField {
    salutation: TextSelectField
    otherSalutation: TextField

    constructor(props: SalutationFieldProps, context?: any) {
        super(props, context);

        //this.state = {}
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
        validateFieldsEx(focus, callback,
            this.salutation,
            this.otherSalutation
        );
    }

    setError(errorText?: string, callback?: { (): any }) {
    }

    render() {
        let salutationDataSource = [{ value: "Mr", label: 'Mr' }, { value: "Mrs", label: 'Mrs' }, { value: "Miss", label: 'Miss' }, { value: "Ms", label: 'Ms' }, { value: "Other", label: 'Other' }];

        let salutation = this.props.value;
        if (salutation && salutationDataSource.filter(r => r.value == salutation).length == 0) {
            salutation = "Other"
        }

        return <div>
            <TextSelectField ref={r => this.salutation = r}
                id={`${this.props.id}_select`}
                label={this.props.label}
                value={salutation}
                onChange={v => this.props.onChange(v)}
                dataSource={salutationDataSource}
                block={false}
                required={this.props.required}
                preview={this.props.preview}
            />
            <TextField ref={r => this.otherSalutation = r}
                id={`${this.props.id}_text`}
                label={`Other ${this.props.label}`}
                value={this.props.value == "Other" ? "" : this.props.value}
                onChange={v => this.props.onChange(v)}
                visible={salutation == "Other"}
                required={salutation == "Other"}
                maxLength={50}
                preview={this.props.preview}
            />
        </div>
    }
}